// extracted by mini-css-extract-plugin
export default {"home":"AboutUs_home__DRrCO"};